import Link from "next/link";

import { Text } from "@/src/components/ui/Typography";
import { cn } from "@/src/lib/utils";

import type { FooterLinkColumnProps } from "./FooterLinkColumn.types";

// Long lists (currently only Services) wrap into a second column under the
// same heading instead of growing the footer's height indefinitely.
const SPLIT_THRESHOLD = 7;

export function FooterLinkColumn({ title, links, className }: FooterLinkColumnProps) {
  const isSplit = links.length > SPLIT_THRESHOLD;
  const columns = isSplit
    ? [links.slice(0, SPLIT_THRESHOLD), links.slice(SPLIT_THRESHOLD)]
    : [links];

  return (
    <div className={cn(className)}>
      <div className="flex items-center gap-3">
        <div aria-hidden className="h-0.5 w-5 rounded-full bg-brand" />
        <Text as="p" role="heading" aria-level={3} size="labelLG" className="tracking-widest text-neutral-500 uppercase">
          {title}
        </Text>
      </div>

      <div className={cn("mt-6 grid gap-x-6 gap-y-4", isSplit && "grid-cols-2")}>
        {columns.map((columnLinks, columnIndex) => (
          <ul key={columnIndex} className="flex flex-col gap-4">
            {columnLinks.map((link) => (
              <li key={link.href}>
                <Link href={link.href}>
                  <Text
                    as="span"
                    size="bodySM"
                    className="inline-block text-neutral-700 transition-[color,transform] duration-300 hover:text-brand"
                  >
                    {link.label}
                  </Text>
                </Link>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}
